function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zm-.67 2L12 10.75 5.67 6zM19 18H5a1 1 0 01-1-1V7.25l7.4 5.55a1 1 0 00.6.2 1 1 0 00.6-.2L20 7.25V17a1 1 0 01-1 1z",
  "data-name": "email"
}));

function SvgIconEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBkYXRhLW5hbWU9ImVtYWlsIj48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIG9wYWNpdHk9IjAiLz48cGF0aCBkPSJNMTkgNEg1YTMgMyAwIDAgMC0zIDN2MTBhMyAzIDAgMCAwIDMgM2gxNGEzIDMgMCAwIDAgMy0zVjdhMyAzIDAgMCAwLTMtM3ptLS42NyAyTDEyIDEwLjc1IDUuNjcgNnpNMTkgMThINWExIDEgMCAwIDEtMS0xVjcuMjVsNy40IDUuNTVhMSAxIDAgMCAwIC42LjIgMSAxIDAgMCAwIC42LS4yTDIwIDcuMjVWMTdhMSAxIDAgMCAxLTEgMXoiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgIconEmail as ReactComponent };